'use strict';
angular.module('schoolLinqApp').directive('rcTextField', function () {
	return {
		require: ['ngModel'],
		scope: {
			labelName: '@',
			ngModel: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/reports/rcTextField.html'),
	};
});
